import { jsx as _jsx } from "react/jsx-runtime";
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { VERIFICATION_TEST_ID } from '../../../constants';
import { getStorybookComponent, isStorybook7 } from '../../helpers';
import { RunnerBridge } from '../../../helpers';
import { useRef } from 'react';
import SherloModule from '../../../SherloModule';
/**
 * We applied styles based on how they are defined in the link below to ensure that user's stories
 * look exactly the same in Sherlo as they do in their Storybook
 *
 * Storybook 8: https://github.com/storybookjs/react-native/blob/v8.6.0/packages/react-native/src/View.tsx
 * Storybook 7: https://github.com/storybookjs/react-native/blob/v7.6.20/packages/react-native/src/components/OnDeviceUI/OnDeviceUI.tsx
 */
function Storybook({ params, uiSettings, view, }) {
    const insets = useSafeAreaInsets();
    const reportedSherloJSLoaded = useRef(false);
    const StorybookComponent = getStorybookComponent({
        view,
        params,
        isTestingMode: true,
    });
    let style;
    if (isStorybook7) {
        style = {
            flex: 1,
            paddingBottom: uiSettings.shouldAddSafeArea ? insets.bottom : 0,
            paddingTop: uiSettings.shouldAddSafeArea ? insets.top : 0,
            // We are typechecking with Storybook 8 so we need to ignore the error
            // @ts-ignore
            backgroundColor: uiSettings.theme.preview.backgroundColor,
        };
    }
    else {
        style = {
            flex: 1,
            paddingTop: uiSettings.shouldAddSafeArea ? insets.top : 0,
            backgroundColor: uiSettings.theme.background.content,
        };
    }
    if (!reportedSherloJSLoaded.current) {
        reportedSherloJSLoaded.current = true;
        const content = {
            action: 'JS_LOADED',
            timestamp: Date.now(),
            entity: 'app',
        };
        const lastState = SherloModule.getLastState();
        if (lastState === null || lastState === void 0 ? void 0 : lastState.requestId) {
            content.requestId = lastState.requestId;
        }
        const contentString = JSON.stringify(content);
        SherloModule.appendFile('protocol.sherlo', `${contentString}\n`);
    }
    RunnerBridge.log('storybook style', { style });
    return (_jsx(View, { testID: VERIFICATION_TEST_ID, style: style, children: _jsx(View, { style: { flex: 1, overflow: 'hidden' }, children: _jsx(StorybookComponent, {}) }) }));
}
export default Storybook;
//# sourceMappingURL=Storybook.js.map